(function () {
  'use strict';

  if (window.NSKlaviyoCart) return;

  var trackedResponses = new WeakSet();

  function absoluteUrl(value) {
    return value ? new URL(value, window.location.origin).href : '';
  }

  function trackAddedItems(data) {
    var addedItems = Array.isArray(data.items) ? data.items : [data];
    addedItems = addedItems.filter(function (line) {
      return line && line.product_id && line.variant_id && line.quantity > 0;
    });
    if (!addedItems.length) return;

    // Keep the existing event name and product fields used by Klaviyo flows.
    // A bundle is one addition; retain every returned line in AddedItems.
    var product = addedItems[0];
    var event = {
      ProductID: product.product_id,
      VariantID: product.variant_id,
      ProductName: product.product_title || product.title,
      SKU: product.sku || '',
      Brand: product.vendor || '',
      Price: product.price / 100,
      URL: absoluteUrl(product.url),
      ImageURL: absoluteUrl(product.image || (product.featured_image || {}).url),
      // Shopify returns the resulting line quantity, not the quantity delta.
      Quantity: product.quantity,
      AddedItems: addedItems
    };

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return window.fetch(root + 'cart.js', { method: 'GET' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart for Klaviyo');
        return response.json();
      })
      .then(function (cart) {
        event.total_price = cart.total_price / 100;
        event.$value = cart.total_price / 100;
        event.total_discount = cart.total_discount;
        event.original_total_price = cart.original_total_price / 100;
        event.items = cart.items;
      })
      .catch(function () {
        // The addition succeeded even if cart enrichment failed. Do not invent totals.
      })
      .then(function () {
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Added to Cart', event]);
      });
  }

  window.NSKlaviyoCart = {
    // Call only with a response from a cart-add POST. Never track button clicks.
    trackAddedResponse: function (response) {
      if (!response || !response.ok || trackedResponses.has(response)) return;

      // Cloning preserves the response body for the cart UI. Tracking is isolated
      // so unavailable analytics or malformed responses cannot break checkout.
      try {
        var copy = response.clone();
        trackedResponses.add(response);
        return Promise.resolve()
          .then(function () { return copy.json(); })
          .then(trackAddedItems)
          .catch(function () {});
      } catch (error) {
        return;
      }
    }
  };
})();
